module.exports = __webpack_public_path__ + "img/water-truck-icon.657b2b9f.svg";